import React, { useState } from "react";
import { Box } from "@mui/material";
import Sidebar from "../../components/sidebar";
import Navbar from "../../components/navbar";
import { Outlet, useLocation } from "react-router-dom";
import { AttendanceProvider } from "../../context/AttendanceContext";

// Pages built to be full-bleed (they manage their own background/height for
// the whole tab) — these skip the default page padding instead of sitting
// inset inside it.
const FULL_BLEED_PATTERNS = [
    /\/timesheet-management\/[^/]+$/,
    /\/my-timesheet\/[^/]+$/,
];

const DashboardLayout = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();
    const isFullBleed = FULL_BLEED_PATTERNS.some((re) => re.test(location.pathname));

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <AttendanceProvider>
            <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f2f4f8", width: "100%", overflowX: "hidden" }}>
                <Navbar onMenuClick={handleDrawerToggle} />

                <Sidebar
                    mobileOpen={mobileOpen}
                    handleDrawerToggle={handleDrawerToggle}
                />

                <Box component="main" sx={{ flexGrow: 1, width: { xs: '100%', md: `calc(100% - 260px)` }, minWidth: 0, maxWidth: '100%' }}>
                    <Box sx={{ height: '70px', flexShrink: 0 }} />
                    {isFullBleed ? (
                        <Outlet />
                    ) : (
                        <Box sx={{ p: { xs: 1.5, sm: 2.5, md: 3.5 }, overflowX: 'clip' }}>
                            <Outlet />
                        </Box>
                    )}
                </Box>
            </Box>
        </AttendanceProvider>
    );
};

export default DashboardLayout;